import { useMemo } from "react";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { ButtonsWrapper } from "src/styled";

import AddCheckListButton from "./AddCheckListButton";
import { useChecklistsContext } from "./CheckListsContext";
import { CheckListType } from "./CheckLists.types";
import { useParams } from "react-router-dom";
import LocalSearch from "../../../../shared/LocalSearch/LocalSearch";

const CheckListsHeader = () => {
  const {
    logbooks,
    defaultChecklists,
    setChecklists,
    resetSearch,
    setResetSearch,
  } = useChecklistsContext();
  const { lbid } = useParams();

  const name = useMemo(() => {
    if (lbid) {
      const lb = logbooks.find(el => el.value === lbid);
      return lb ? lb.label : "";
    }
  }, [logbooks, lbid]);

  return (
    <Breadcrumbs
      border={false}
      customLastEl={lbid && name ? { title: name, href: "." } : undefined}>
      <ButtonsWrapper>
        {lbid && (
          <LocalSearch
            defaultData={defaultChecklists}
            setData={setChecklists}
            searchByProperty="name"
            resetSearch={resetSearch}
            setResetSearch={setResetSearch}
          />
        )}
        <AddCheckListButton title="Add Group +" type={CheckListType.Group} />
        <AddCheckListButton
          title="Add Checklist +"
          type={CheckListType.Single}
        />
      </ButtonsWrapper>
    </Breadcrumbs>
  );
};

export default CheckListsHeader;
